import React from 'react';
import { GRID_COL_COUNT } from '../utils/containerDispatchGrid';
import './ContainerDispatchGridHeader.css';

interface Props {
  colWidths: number[];
  rowHeaderWidth: number;
  tableWidth: number;
}

const ContainerDispatchGridHeader: React.FC<Props> = ({
  colWidths,
  rowHeaderWidth,
  tableWidth,
}) => {
  const widths = colWidths.length === GRID_COL_COUNT
    ? colWidths
    : Array.from({ length: GRID_COL_COUNT }, (_, i) => colWidths[i] ?? 50);

  return (
    <div className="cd-custom-header-scroll" style={{ width: tableWidth }}>
      <table className="cd-custom-header-table" style={{ width: tableWidth }}>
        <colgroup>
          <col style={{ width: rowHeaderWidth }} />
          {widths.map((w, i) => (
            <col key={i} style={{ width: w }} />
          ))}
        </colgroup>
        <thead>
          <tr>
            <th rowSpan={2} className="cd-h-corner" />
            <th rowSpan={2}>거래처</th>
            <th colSpan={2}>도착 창고및업체</th>
            <th rowSpan={2}>품명</th>
            <th>LINE</th>
            <th>규격</th>
            <th>무게</th>
            <th>F</th>
            <th>E</th>
            <th>반출터미널</th>
            <th rowSpan={2}>운송업체</th>
            <th>차량번호</th>
            <th>컨테이너번호</th>
            <th className="cd-h-billing">청구액</th>
            <th rowSpan={2}>정상요율</th>
            <th rowSpan={2}>비고</th>
          </tr>
          <tr>
            <th>도착지역</th>
            <th>연락처</th>
            <th colSpan={2}>면허</th>
            <th colSpan={3}>B/L no</th>
            <th>반납터미널</th>
            <th>연락처</th>
            <th>품명 및 비고</th>
            <th className="cd-h-payment">하불액</th>
          </tr>
        </thead>
      </table>
    </div>
  );
};

export default ContainerDispatchGridHeader;
